var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pointCloudController.canLoadCloud)?_c('point-cloud-viewer',{attrs:{"canEdit":false}}):_c('p-content-placeholder',{attrs:{"image":require('../background_empty.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }